//  popupslider
function initSlickSider(){
$('.slder-pop').not('.slick-initialized').slick({
  dots: true,
  infinite: true,
  autoplay: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  prevArrow: '<button class="flickity-button flickity-prev-next-button previous"><img src="https://cdn.shopify.com/s/files/1/0565/3404/0773/files/prev.png?v=1680143268"></button>',
  nextArrow: '<button class="flickity-button flickity-prev-next-button next"><img src="https://cdn.shopify.com/s/files/1/0565/3404/0773/files/next.png?v=1680143268"></button>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
         dots: true
      }
    }
    ]
});
}

function initAllSlick(){
  if (!(window.jQuery && jQuery.fn && jQuery.fn.slick)) { return; }
  var $ = jQuery;
  // Custom slider implementation for .slder-news - handled in news-updates.liquid
  // Skipping Slick initialization for news slider to use custom slider instead
  $('.slder-news').not('.slick-initialized').each(function() {
    var $slider = $(this);
    // Only initialize if not inside news-slider-wrapper (custom slider)
    if (!$slider.closest('.news-slider-wrapper').length) {
      // This is for other sliders using .slder-news class
      // Keep existing initialization if needed for other sections
    }
  });


  $('.slide-eco').not('.slick-initialized').slick({
    dots: false,
    infinite: false,
    autoplay: false,
    centerMode: false,
    centerPadding: '40px',
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '<button class="flickity-button flickity-prev-next-button previous"><img src="https://cdn.shopify.com/s/files/1/0565/3404/0773/files/left-ree.png?v=1685361380"></button>',
    nextArrow: '<button class="flickity-button flickity-prev-next-button next"><img src="https://cdn.shopify.com/s/files/1/0565/3404/0773/files/right-reee.png?v=1685361379"></button>',
    responsive: [
      { breakpoint: 990, settings: { arrows: true, slidesToShow: 2 } },
      { breakpoint: 500, settings: { arrows: true, slidesToShow: 1 } }
    ]
  });



// popup-ppd
$('.pop-u').on('click touch', function(){
  initSlickSider();
$('.popup-new').show();
});         
$(document).on('click touch', function(event) {
if (!$(event.target).parents().addBack().is('.pop-u')) {
$('.popup-new').hide();
}
});
$('.popup-new').on('click touch', function(event) {
event.stopPropagation();
});
$('.close').click(function() {
$(".popup-new").fadeOut(300);
});

//  slider-ppd-icon
  $('.Icons-sld').not('.slick-initialized').slick({
  dots: true,
  infinite: true,
  autoplay: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  prevArrow: '<button class="flickity-button flickity-prev-next-button previous"><img src="https://cdn.shopify.com/s/files/1/0565/3404/0773/files/prev.png?v=1680143268"></button>',
  nextArrow: '<button class="flickity-button flickity-prev-next-button next"><img src="https://cdn.shopify.com/s/files/1/0565/3404/0773/files/next.png?v=1680143268"></button>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false
      }
    }
    ]
});

// $('.js-anchor-link').click(function(e){
//   e.preventDefault();
//   let target = '';
//   if ($(window).width() < 720) {
//     target = $($(this).attr('href').replace('#', '.'));
//       if(target.length){
//         var scrollTo = target.offset().top - 70;
//         console.log(target.length);
//         $('body, html').animate({scrollTop: scrollTo+'px'}, 100);
//       }
//   }else{
//     target = $($(this).attr('href'));
//       if(target.length){
//         var scrollTo = target.offset().top;
//         console.log(target.length);
//         $('body, html').animate({scrollTop: scrollTo+'px'}, 100);
//       }
//   }
// });





// $('.js-anchor-link').click(function(e){
//   e.preventDefault();
//   var target = $($(this).attr('href'));
//   if(target.length){
//     var scrollTo = target.offset().top;
//     $('body, html').animate({scrollTop: scrollTo+'px'}, 100);
//   }
// });




  $('.e-bike-pages-slider').not('.slick-initialized').slick({
   dots: false,
  infinite: true,
  autoplay: false,
  centerMode: true,
  centerPadding: '0px',
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: '<button class="flickity-button flickity-prev-next-button previous"><img src="https://cdn.shopify.com/s/files/1/0565/3404/0773/files/left-ree.png?v=1685361380"></button>',
  nextArrow: '<button class="flickity-button flickity-prev-next-button next"><img src="https://cdn.shopify.com/s/files/1/0565/3404/0773/files/right-reee.png?v=1685361379"></button>',
 responsive: [
    {
      breakpoint: 767,
      settings: {
        arrows: true,
        slidesToShow: 1
      }
    }
  ]
});


  $('.e-bike-pages-slidered').not('.slick-initialized').slick({
  dots: false,
  infinite: true,
  autoplay: false,
  centerMode: true,
  autoplaySpeed: false,
  centerPadding: '0px',
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: '<button class="flickity-button flickity-prev-next-button previous"><img src="https://cdn.shopify.com/s/files/1/0565/3404/0773/files/left-ree.png?v=1685361380"></button>',
  nextArrow: '<button class="flickity-button flickity-prev-next-button next"><img src="https://cdn.shopify.com/s/files/1/0565/3404/0773/files/right-reee.png?v=1685361379"></button>',
  responsive: [
    {
      breakpoint: 767,
      settings: {
        arrows: true,
        slidesToShow: 1
      }
    }
  ]
});


  $('.e-bike-pages-slider-gcs-new').not('.slick-initialized').slick({
  dots: true,
  infinite: true,
  autoplay: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: '<button class="flickity-button flickity-prev-next-button previous"><img src="https://cdn.shopify.com/s/files/1/0565/3404/0773/files/left-ree.png?v=1685361380"></button>',
  nextArrow: '<button class="flickity-button flickity-prev-next-button next"><img src="https://cdn.shopify.com/s/files/1/0565/3404/0773/files/right-reee.png?v=1685361379"></button>',
});

  $('.e-bike-banner-slider').not('.slick-initialized').slick({
  dots: true,
  infinite: true,
  autoplay: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: '<button class="flickity-button flickity-prev-next-button previous"><img src="https://cdn.shopify.com/s/files/1/0565/3404/0773/files/left-ree.png?v=1685361380"></button>',
  nextArrow: '<button class="flickity-button flickity-prev-next-button next"><img src="https://cdn.shopify.com/s/files/1/0565/3404/0773/files/right-reee.png?v=1685361379"></button>',
});


  $('.reviews-slider-one').not('.slick-initialized').slick({
  dots: false,
  infinite: true,
  arrows: false,
  autoplay: true,
  slidesToScroll: 4,
  autoplaySpeed: 1,
  speed: 12000,
  cssEase: 'linear',
  centerPadding: '0px',
  slidesToShow: 3,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        arrows: false,
        centerMode: true,
        slidesToShow: 1
      }
    }
  ]
});

$(function () {
    var maxL = 80;
    $('.content-read-more-op p').each(function () {
        var text = $(this).text();
        if (text.length > maxL) {
            var begin = text.substr(0, maxL),
                end = text.substr(maxL);
            $(this).html(begin)
                .append($('<div class="hidden" />').html(end).hide())  // Hidden content
                .append($('<a class="readmore"/>').attr('href', '#!').html('read more...').css('display', 'inline-block').css('margin-left', '10px')); // Apply additional styles
        }
    });

    $(document).on('click', '.readmore', function () {
        var $this = $(this);
        var hiddenContent = $this.prev('.hidden');
        if (hiddenContent.is(':visible')) {
            hiddenContent.slideUp(400);
            $this.html('read more...');
        } else {
            hiddenContent.slideDown(400);
            $this.html('read less');
        }
    });
});


// $(document).ready(function () {
// $(".E-Bike.template-product .product-single__title").each(function () {
// let words = $(this).text().split(" ")
// if (words.length >= 2) {
// words[0] = `<span style="color: #e31e24;">${words[0]}</span>`;
// words[1] = `<span style="color: #e31e24;">${words[1]}</span>`;
// }
// $(this).html(words.join(" "));
// });
// });



  $('.reviews-slider-two').not('.slick-initialized').slick({
  rtl: true,
  dots: false,
  infinite: true,
  arrows: false,
  slidesToScroll: 4,
  autoplay: true,
  autoplaySpeed: 1,
  speed: 12000,
  cssEase: 'linear',
  centerPadding: '0px',
  slidesToShow: 3,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        arrows: false,
        centerMode: true,
        slidesToShow: 1,
        
      }
    }
  ]
});  

}

function waitAndInitSlick(){
  if (window.jQuery && jQuery.fn && jQuery.fn.slick){
    initAllSlick();
  } else {
    setTimeout(waitAndInitSlick, 50);
  }
}

document.addEventListener('DOMContentLoaded', waitAndInitSlick);
document.addEventListener('shopify:section:load', waitAndInitSlick);

document.addEventListener('DOMContentLoaded', function() {
    var priceElements = document.querySelectorAll('span, span.product__price-savings, .pp-real-f, .grid-product__price--original, .grid-product__price--savings, .slier-h3, .grid-product__price, .grid-product__price span'); 

    priceElements.forEach(function(priceElement) {
        var priceText = priceElement.innerText || priceElement.textContent;
        if (priceText.endsWith('.00')) {
            priceElement.innerText = priceText.replace('.00', '');
        }
    });
});

